import React from 'react'

import { Button, Column, Text } from 'Components/UI'

import { Brain003Glyph, BrainDrawGlyph, BrainGlyph } from 'Assets/Svg/Brain'

import { LANDING_INLINE_PADDINGS } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { useAppContext } from 'Services/AppContext'

import {
  BackgroundAnimated,
  BackgroundBase,
  Container,
  Content,
  InvertedText,
} from './styles'
import TypewriterWords from './TypewriterWords'

const WORDS = ['AI', 'Mobile', 'Web', 'Data']

function AgencyHeroSection() {
  const { isMobile } = useResponsiveLayout()
  const { openSupportWidget } = useAppContext()

  return (
    <Container>
      <BackgroundBase>{BrainGlyph()}</BackgroundBase>

      <BackgroundAnimated>{BrainDrawGlyph()}</BackgroundAnimated>

      <BackgroundBase
        animate={{ opacity: 1 }}
        initial={{ opacity: 0 }}
        transition={{
          delay: 4.5,
          duration: 1.5,
          ease: 'easeOut',
        }}
      >
        {Brain003Glyph()}
      </BackgroundBase>

      <Content
        pb={100}
        pt={[396, 396, 396, 396, 480]}
        px={LANDING_INLINE_PADDINGS}
      >
        <Column fullWidth>
          <Text
            as="h1"
            mb={5}
            medium
            title
            title40={isMobile}
            title52={!isMobile}
          >
            We marry
            <br />
            brilliant ideas
            <br />
            with&nbsp;
            <InvertedText
              as="span"
              medium
              title40={isMobile}
              title52={!isMobile}
            >
              <TypewriterWords words={WORDS} />
            </InvertedText>
            &nbsp;tech
          </Text>

          <Text body body16 mb={9} semiLight>
            The main ingredients are the people and the system
          </Text>

          <Button onClick={openSupportWidget}>Book a paid discovery</Button>
        </Column>
      </Content>
    </Container>
  )
}

export default AgencyHeroSection
